export default __webpack_public_path__ + "static/media/withdraw-ecredit-step3.4cb83506.png";